import { render } from "./box_success.vue?vue&type=template&id=7cc56542&scoped=true"
import script from "./box_success.vue?vue&type=script&lang=js"
export * from "./box_success.vue?vue&type=script&lang=js"

import "./box_success.vue?vue&type=style&index=0&id=7cc56542&scoped=true&lang=css"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc56542"]])

export default __exports__